import { useMemo } from 'react'

import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Link } from '@tanstack/react-router'
import { createColumnHelper } from '@tanstack/react-table'

import { Plus } from '@/components/icons'
import { PageCard, PageLayout } from '@/components/ui/page'
import {
	CellText,
	CellTextDate,
	DataTable,
	useDataTable,
} from '@/components/ui/table/data-table'

import { useAuth } from '@/libs/hooks/use-auth'

import { unitList } from '@/features/unit/api'
import type { IUnit } from '@/features/unit/type'

export const Route = createFileRoute('/_app/inventory/unit/')({
	component: RouteComponent,
})

function RouteComponent() {
	return (
		<PageLayout>
			<PageLayout.Header
				breadcrumbs={[
					['/inventory', 'Inventory'],
					['/inventory/unit', 'Konversi Unit'],
				]}
			/>

			<PageCard>
				<PageCard.Header
					title="Konversi Unit"
					actions={
						<PageCard.HeaderAction asChild>
							<Link from={Route.fullPath} to="/inventory/unit/create">
								<Plus />
								Tambah Konversi
							</Link>
						</PageCard.HeaderAction>
					}
				/>
				<PageCard.Content>
					<UnitTable />
				</PageCard.Content>
			</PageCard>
		</PageLayout>
	)
}

function UnitTable() {
	const { outletId: oId } = useAuth((s) => s.outlet)

	const { data, isLoading } = useQuery(unitList.qry({ oId }))
	const columns = useMemo(getColumns, [])
	const { table } = useDataTable({
		columns,
		data: data?.units ?? [],
		getRowId: (row) => row.id,
	})

	return <DataTable isLoading={isLoading} table={table} columns={columns} />
}

const ch = createColumnHelper<IUnit>()

function getColumns() {
	return [
		ch.accessor('name', {
			header: 'Nama konversi',
			cell: ({ row }) => (
				<Link
					from={Route.fullPath}
					to="/inventory/unit/$id"
					params={{ id: row.original.id }}
				>
					<CellText text={row.original.name} asLink />
				</Link>
			),
		}),
		ch.accessor('convs.name', {
			header: 'Konversi',
			cell: ({ row }) => (
				<CellText text={row.original.convs.map((x) => x.name).join(', ')} />
			),
		}),
		ch.accessor((r) => r.convs.length, {
			header: 'Total Unit Konversi',
			cell: ({ row }) => (
				<CellText text={`${row.original.convs.length} Konversi`} />
			),
		}),
		ch.accessor('createdAt', {
			header: 'Created At',
			cell: ({ row }) => <CellTextDate date={row.original.createdAt} />,
		}),
		ch.accessor('updatedAt', {
			header: 'Updated At',
			cell: ({ row }) => <CellTextDate date={row.original.createdAt} />,
		}),
	]
}
